export default __webpack_public_path__ + "assets/images/48f72e45827c6b91fde520e45279012e.jpg";